<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card>
			<v-card-title>
				<span>Papildomų resursų prašymas</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-select
						label="Tipas"
						hide-details
						v-model="type"
						filled
						class="body-2 mt-2"
						:rules="rules"
						:items="typeItems"
						item-value="key"
						item-text="name"
						:key="getKey('type')"
					></v-select>
					<v-text-field
						label="Prašomo resurso kiekis"
						hide-details
						v-model="value"
						filled
						class="mt-2"
						:rules="rules"
						type="number"
						:key="getKey('value')"
					></v-text-field>
					<v-textarea
						label="Pranešimas"
						dense
						hide-details
						filled
						v-model="message"
						:height="120"
						no-resize
						class="mt-2"
						:rules="rules"
						:key="getKey('message')"
					></v-textarea>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="sendRequest"
					outlined
					small
					:loading="requestInAction"
				>
					Prašyti papildomų resursų
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="requestInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";

	export default {
		data: function(){
			var data = {
				dialog: false,
				requestInAction: false,
				typeItems: [{
					key: "MaxInteractiveAtlas",
					name: AdminHelper.getAttributeTitle("MaxInteractiveAtlas") // Reikšmė?
				},{
					key: "MaxPrintAtlas",
					name: AdminHelper.getAttributeTitle("MaxPrintAtlas") // Reikšmė?
				},{
					key: "MaxMb",
					name: AdminHelper.getAttributeTitle("MaxMb") // Reikšmė?
				},{
					key: "MaxAll",
					name: AdminHelper.getAttributeTitle("MaxAll") // Reikšmė?
				},{
					key: "Other",
					name: AdminHelper.getAttributeTitle("Other") // Reikšmė?
				}],
				type: null,
				value: null,
				message: null,
				rules: [v => !!v || "Laukas privalomas"],
				iteration: 0
			};
			return data;
		},
		created: function(){
			this.$vBus.$on("show-more-resources-request-form", this.showForm);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-more-resources-request-form", this.showForm);
		},
		methods: {
			closeDialog: function(){
				this.dialog = false;
			},
			showForm: function(){
				this.iteration += 1;
				this.type = this.value = this.message = null;
				this.dialog = true;
			},
			sendRequest: function(){
				var formValid = this.$refs.form.validate();
				if (formValid) {
					this.requestInAction = true;
					var params = {
						type: this.type,
						typePretty: AdminHelper.getAttributeTitle(this.type),
						value: this.value,
						message: this.message
					};
					var def = AdminHelper.requestResources(params);
					def.then(function(){
						this.requestInAction = false;
						this.dialog = false;
						this.$vBus.$emit("show-message", "Ačiū, prašymą gavome");
					}.bind(this), function(){
						this.$vBus.$emit("show-message", "error");
						this.requestInAction = false;
					}.bind(this));
				}
			},
			getKey: function(key){
				key = key + "-" + this.iteration;
				return key;
			}
		}
	}
</script>